'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasName = exports.isInNamespace = exports.hasLocalName = exports.namespaceUri = exports.localName = undefined;

var _ramda = require('ramda');

var _shared = require('./shared');

var _constants = require('./shared/constants');

var localName = (0, _ramda.prop)(_constants.LOCAL_NAME);
var namespaceUri = (0, _ramda.compose)(_shared.normalizeToNull, (0, _ramda.prop)(_constants.NAMESPACE_URI));

var hasLocalName = function hasLocalName(name) {
    return (0, _ramda.compose)((0, _ramda.equals)(name), localName);
};
var isInNamespace = function isInNamespace(uri) {
    return (0, _ramda.compose)((0, _ramda.equals)((0, _shared.normalizeToNull)(uri)), namespaceUri);
};
var hasName = function hasName(localName, uri) {
    return (0, _ramda.both)(hasLocalName(localName), isInNamespace(uri));
};

exports.localName = localName;
exports.namespaceUri = namespaceUri;
exports.hasLocalName = hasLocalName;
exports.isInNamespace = isInNamespace;
exports.hasName = hasName;